import React from 'react';

const VectorDown = () => (
  <svg width="6" height="4" viewBox="0 0 6 4" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M0 .5l3 3 3-3H0z" fill="currentColor" />
  </svg>
);

export default VectorDown;
